<template>
	<div class="coensmCmss">
		<div class="promote">
			<van-nav-bar title="Bônus de suporte diário de perda" left-arrow fixed placeholder :right-text="$t('promote._Histórico')"
				@click-right="openUrl('records')" @click-left="onClickLeft" />
			<div class="_event-lucky-wheel_1yc53_17">
				<div class="R57xbU1vEwuho81iaSVT-conter" style="margin-bottom: .2rem;">
					<div class="van-row">
						<div class="van-col van-col--12">
							<label>{{$t('promote._Perdasdeontem')}}</label>
							<span class="currencyAmount red">{{formDate.loss}}</span>
						</div>
						<div class="van-col van-col--12">
							<label>{{$t('promote._Bnusdesuportehoje')}}</label>
							<span class="currencyAmount yellow">{{formDate.subsidy}}</span>
						</div>
					</div>
					<div class="footerOCmens conterms">
						<div style="padding: 0 .5rem;">{{$t('promote._Valordaperda')}}</div>
						<div style="padding: 0 .5rem;">{{$t('promote._PrmiosExtra')}} (%)</div>
					</div>
					<div class="conterms" v-for="(item,index) in formDate.list">
						<div style="padding: 0 .5rem;color: var(--theme-text-color-lighten);">≥ {{item.loss}}</div>
						<div style="padding: 0 .5rem;color: var(--theme-secondary-color-finance);">{{item.rate}}</div>
					</div>
				</div>
				
				<div class="public-introduction _introduction_109ll_17">
					<div class="introduction-inner">
						<div v-html="formDate.desc"></div>
						</div>
					</div>
				</div>
			</div>
			
			<!--  -->
			<div class="orkXHvtNM5R_5twq6l5I">
				<button type="button"
					@click="onClickLeft"
					class="ant-btn RRWQlUJLCPB59ggBUdFl">{{$t('_buome._Retornar')}}</button>
					<van-button @click="ReceberTudo" class="ant-btn ant-btn-primary yJrr5gS3ZL4NGzZkaPXH" v-if="formDate.open_tips"  type="info" native-type="submit"> {{$t('_home._ReceberTudo')}}</van-button>
					<van-button class="ant-btn ant-btn-primary1 yJrr5gS3ZL4NGzZkaPXH" v-else type="info" native-type="submit"> {{$t('_home._ReceberTudo')}}</van-button>
			</div>
			<event></event>
		</div>
</template>

<script>
	
	import {
		luckyTurntable,
		startTurntable,
		claimActivityRewards,
		lossSubsidy
	} from "@/apis/modules/detail.js"
	import { Toast } from 'vant';
	import event from "@/components/event.vue"
	import {
		mapState
	} from 'vuex';
	export default {
		components:{
			event
		},
		computed: {
			...mapState(['popList', 'tabNav', 'banner', 'sidebarsList', 'marquee'])
		},
		data() {
			return {
				tabIntdex: 'none',
				type:1,
				formDate:{
					
				},
				is_my:0,
			}
		},
		created() {
			this.getNotification();
			// this.startTurntable();
		},
		methods: {
			startTurntable() {
				startTurntable({
					type: this.type
				}).then(({
					code,
					data,
					msg
				}) => { //404
					let {
						marquee
					} = data;
				})
			},
			getNotification() {
				lossSubsidy({
				}).then(({
					code,
					data,
					msg
				}) => { //404
					let {
						marquee
					} = data;
					this.formDate=data
					
				})
			},
			ReceberTudo(){
				claimActivityRewards({
					activity:'lossSubsidy'
				}).then(({
					code,
					data,
					msg
				}) => { //404
					if(code==0){
						Toast.success(msg);
						this.getNotification();
					}else{
						Toast.loading(msg);
					}
				})
			},
			Detalhes(){
				
			},
			onClickLeft() {
				this.$router.go(-1);
			}
		}
	}
</script>

<style>
	/* --theme-alt-neutral-2 */
	.coensmCmss .van-nav-bar__right,
	.coensmCmss .van-nav-bar__text {
		color: var(--theme-primary-color) !important;
	}

	._event-lucky-wheel_1yc53_17 {
		padding: .2rem
	}
	._introduction_109ll_17 .introduction-inner {
	    padding: .2rem;
	    overflow-y: auto;
	    color: var(--theme-text-color);
	    font-size: .26rem;
	    line-height: .42rem;
	    white-space: pre-wrap;
	    word-break: break-word;
	    background-color: var(--theme-main-bg-color);
	    border-radius: .1rem;
	    box-shadow: 0 .03rem .09rem rgba(0,0,0,.06)
	}
	._introduction_109ll_17 .introduction-inner .text-darken {
	    font-weight: 700
	}


	._event-lucky-wheel_1yc53_17 .lucky-wheel-item {
	}

	._event-lucky-wheel_1yc53_17 .turntable {
		padding: 0 .2rem .2rem
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs {
		flex: 1;
		background-color: var(--theme-main-bg-color);
		border-radius: .14rem;
		box-shadow: 0 .03rem .09rem 0 var(--theme-bg-shadow)
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap {
		height: .8rem;
		padding: 0 .2rem;
		border-bottom: var(--lobby__px) solid var(--theme-color-line)
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap .ui-tabs__nav {
		gap: .6rem;
		overflow-x: scroll;
		overflow-y: hidden;
		max-width: 100%
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__wrap .ui-tab {
		flex: none;
		font-size: .26rem
	}

	._event-lucky-wheel_1yc53_17 .lucky-wheel-tabs .ui-tabs__content {
		height: calc(100% - .8rem);
		padding: .2rem 0 .2rem .2rem
	}

	._event-lucky-wheel_1yc53_17 .public-introduction {
		padding: 0;
		margin-top: 0
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .05rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .05rem;
		box-shadow: 0 .02rem .04rem 0 var(--skin__web_left_bg_shadow)
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 {
		position: relative;
		width: 100%;
		height: .8rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		opacity: 1
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		display: block;
		width: .86rem;
		height: .78rem;
		background-size: 100% 100%
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		border: thin solid var(--skin__primary);
		border-radius: .05rem;
		overflow: hidden
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 i[class~=bg] {
		color: var(--skin__filter_active) !important
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .bg {
		transform: rotate(45deg) scale(1.4);
		position: relative;
		left: .15rem;
		top: .15rem;
		background-color: var(--skin__filter_active)
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .gou {
		z-index: 1
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20:not(._is-checked_hp4jz_68) ._checked-status_hp4jz_44 {
		display: none
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20._is-checked_hp4jz_68 ._checked-status_hp4jz_44 {
		display: block
	}

	._icon-position-left_hp4jz_20._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .05rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .05rem;
		box-shadow: 0 .02rem .04rem 0 var(--skin__web_left_bg_shadow)
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 {
		position: relative;
		width: 100%;
		height: .8rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		opacity: 1
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		display: block;
		width: .86rem;
		height: .78rem;
		background-size: 100% 100%
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		border: thin solid var(--skin__primary);
		border-radius: .05rem;
		overflow: hidden
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 i[class~=bg] {
		color: var(--skin__filter_active) !important
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .bg {
		transform: rotate(45deg) scale(1.4);
		position: relative;
		left: .15rem;
		top: .15rem;
		background-color: var(--skin__filter_active)
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .gou {
		z-index: 1
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20:not(._is-checked_hp4jz_68) ._checked-status_hp4jz_44 {
		display: none
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20._is-checked_hp4jz_68 ._checked-status_hp4jz_44 {
		display: block
	}

	._icon-position-right_hp4jz_81._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 0
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .05rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .05rem;
		box-shadow: 0 .02rem .04rem 0 var(--skin__web_left_bg_shadow)
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 {
		position: relative;
		width: 100%;
		height: .8rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		opacity: 1
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		display: block;
		width: .86rem;
		height: .78rem;
		background-size: 100% 100%
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		border: thin solid var(--skin__primary);
		border-radius: .05rem;
		overflow: hidden
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 i[class~=bg] {
		color: var(--skin__filter_active) !important
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .bg {
		transform: rotate(45deg) scale(1.4);
		position: relative;
		left: .15rem;
		top: .15rem;
		background-color: var(--skin__filter_active)
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._checked-status_hp4jz_44 ._checked-status-subscript_hp4jz_55 .gou {
		z-index: 1
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20:not(._is-checked_hp4jz_68) ._checked-status_hp4jz_44 {
		display: none
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20._is-checked_hp4jz_68 ._checked-status_hp4jz_44 {
		display: block
	}

	._icon-position-none_hp4jz_142._main-img-layout_hp4jz_20 ._nav-item-inner_hp4jz_30 ._active-icon_hp4jz_38 {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		display: none
	}

	._bottom-nav-item_1yyzn_17 ._active-name_1yyzn_17 {
		margin-top: .1rem;
		font-size: .18rem;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis
	}

	._bottom-nav-item_1yyzn_17:not(._is-checked_1yyzn_26) ._active-name_1yyzn_17 {
		color: var(--theme-text-color)
	}

	._bottom-nav-item_1yyzn_17._is-checked_1yyzn_26 ._active-name_1yyzn_17 {
		color: var(--skin__primary)
	}

	._bottom-nav-item_1yyzn_17 {
		opacity: 1
	}

	._activities-bar-item_ycxm1_17 {
		width: 1.88rem
	}

	._events-bar_19vjj_17 {
		display: flex;
		align-items: center;
		padding-bottom: 0;
		justify-content: center;
		width: 100%;
		padding-right: .2rem;
		padding-left: .2rem
	}

	._events-bar_19vjj_17 .ui-tabs {
		max-width: 100%
	}

	._events-bar_19vjj_17 .ui-tabs .ui-tabs__wrap .ui-tabs__nav {
		background-color: transparent
	}

	._events-bar_19vjj_17 .ui-tabs .ui-tabs__wrap {
		border-bottom: unset
	}

	._events-bar_19vjj_17 .ui-tabs__line,
	._events-bar_19vjj_17 .ui-tabs__content {
		display: none
	}

	._events-bar_19vjj_17 .ui-tabs__nav--line {
		padding-bottom: 0
	}

	._events-bar_19vjj_17 ._event-bar-item_19vjj_42 {
		padding: 0;
		margin-right: .2rem
	}

	._events-bar_19vjj_17>div {
		max-width: 100%
	}

	._events-bar_19vjj_17 ._swiper-container_19vjj_49 {
		height: .9rem
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52 {
		flex-shrink: 0;
		width: .4rem;
		height: .4rem;
		margin-bottom: .14rem;
		color: var(--skin__primary);
		font-size: .18rem;
		line-height: .4rem;
		text-align: center;
		background-color: var(--theme-main-bg-color);
		border: thin solid var(--theme-color-line);
		border-radius: 50%;
		cursor: pointer
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52:first-child {
		margin-right: .1rem
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52:last-child {
		margin-left: .1rem
	}

	._events-bar_19vjj_17 ._scrollEvents_19vjj_52._btnDisabled_19vjj_72 {
		color: var(--theme-text-color);
		cursor: no-drop
	}

	._visible-hidden_19vjj_77 {
		visibility: hidden
	}

	._swiperSlideWidth_19vjj_81 {
		width: 1.88rem !important
	}

	._nav2Wraper_19vjj_85 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%
	}

	._nav2Wraper_19vjj_85 li:first-child {
		margin-right: .25rem
	}

	._nav2Wraper_19vjj_85 .swiper-slide,
	._nav4Wrapper_19vjj_100 .swiper-slide {
		width: 1.88rem !important;
		margin-right: .2rem !important;
		transform: translate(-.3rem)
	}

	._navless4Wrapper_19vjj_106 .swiper-slide {
		width: 1.88rem !important
	}

	._header-sub-btn_17wo2_17 {
		position: absolute;
		right: 0;
		width: 1.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 .1rem;
		text-align: center;
		color: var(--skin__primary);
		font-size: .24rem;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical
	}

	._header-sub-btn_17wo2_17:lang(zh) {
		word-break: break-all
	}

	._header-sub-btn_17wo2_17:not(:lang(zh)) {
		word-break: break-word
	}

	._event-item-box_qhu5g_17 .lobby-scroll {
		z-index: initial
	}

	._event-item-box_qhu5g_17 .ui-placeholder__nested-loading {
		max-height: calc(var(--lobby__screen-height) - 1.8rem)
	}

	._event-item-header_qhu5g_24 ._event-header-center_qhu5g_24 {
		max-width: 4.3rem;
		word-break: break-all;
		text-align: center;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical
	}

	._event-item-header_qhu5g_24 ._event-header-center_qhu5g_24:not(:lang(zh)) {
		word-break: break-word
	}

	._customizeWrap_qhu5g_39 {
		min-height: 100%;
		overflow-y: scroll;
		display: flex;
		flex-flow: column
	}

	._placeholder-box_qhu5g_46 {
		min-height: 6rem
	}

	._bar_qhu5g_50._normal_qhu5g_50 {
		margin-bottom: .2rem
	}

	._bar_qhu5g_50._bottom-btn_qhu5g_53 {
		margin-bottom: 1.3rem
	}

	._bar_qhu5g_50._customize-bottom-btn_qhu5g_56 {
		margin-bottom: 1.8rem
	}

	._ranking-list-bottom-box_ov7eu_17 {
		display: flex;
		flex-direction: column;
		margin: .2rem;
		padding: .2rem;
		color: var(--theme-text-color);
		font-size: .22rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._ranking-list-bottom-box_ov7eu_17 .ui-placeholder--nested .ui-placeholder__nested-loading {
		height: calc(.5 * var(--lobby__screen-height) - 1.2rem)
	}

	._ranking-list-bottom-box_ov7eu_17>h1 {
		color: var(--theme-text-color);
		font-size: .24rem;
		text-align: center;
		font-weight: 400;
		margin-bottom: .2rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-box_ov7eu_38 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-info_ov7eu_44 {
		margin-right: .1rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-list-table_ov7eu_47 {
		margin-top: .2rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 {
		text-align: center
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .countdown {
		justify-content: center
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .countdown span {
		color: #fff
	}

	._ranking-list-bottom-box_ov7eu_17 ._refresh-btn_ov7eu_50 .ui-button__text {
		width: 1.2rem;
		line-height: .28rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 {
		margin: 0 .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 .ranking-icon {
		width: .5rem;
		min-height: .3rem;
		position: relative;
		top: .1rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._ranking-today_ov7eu_63 .ranking-icon:lang(zh) {
		margin-top: -.02rem
	}

	._ranking-list-bottom-box_ov7eu_17 ._today-bonus_ov7eu_76 {
		margin-left: .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-bottom-box_ov7eu_17 ._yellow_ov7eu_80 {
		color: var(--skin__accent_3)
	}

	._margin-top-fit_ov7eu_84 {
		margin-top: 0
	}

	._ranking-list-yesterday_1nhqp_17 {
		display: flex;
		flex-direction: column;
		color: var(--theme-text-color);
		font-size: .22rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._ranking-list-yesterday_1nhqp_17 .ui-list {
		max-height: 6.26rem;
		overflow-y: auto
	}

	._ranking-list-top-box_1nhqp_31 {
		display: flex;
		justify-content: space-between
	}

	._ranking-list-top-box_1nhqp_31 ._top_1nhqp_35 {
		display: flex;
		align-items: center;
		height: .48rem
	}

	._ranking-list-top-box_1nhqp_31 p+p {
		margin-top: .12rem
	}

	._ranking-list-top-box_1nhqp_31 ._bottom_1nhqp_43 {
		line-height: 1
	}

	._ranking-list-top-box_1nhqp_31 ._detail_1nhqp_46 {
		margin-left: .1rem;
		color: var(--skin__primary);
		font-size: .22rem;
		cursor: pointer
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-last_1nhqp_52 {
		margin-left: .1rem;
		color: var(--theme-text-color);
		line-height: 1
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-last_1nhqp_52 .ranking-icon {
		width: .5rem;
		min-height: .3rem
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-award_1nhqp_61 {
		margin-left: .1rem
	}

	._ranking-list-top-box_1nhqp_31 ._yellow_1nhqp_64 {
		color: var(--skin__accent_3)
	}

	._ranking-list-top-box_1nhqp_31 ._ranking-list-top-left_1nhqp_67 p {
		display: flex;
		align-items: center
	}

	._detailModal_1nhqp_72 .ui-dialog__header {
		font-size: .24rem;
		height: .74rem;
		color: var(--theme-text-color)
	}

	._ranking-list-top-container_orrvr_17 {
		position: sticky;
		top: 0;
		padding: .2rem;
		background-color: var(--skin__bg_1);
		z-index: 2
	}

	._ranking-list-top-box_orrvr_25 {
		display: flex;
		justify-content: space-between;
		height: 1.32rem;
		padding: .2rem;
		color: var(--theme-text-color);
		font-size: .22rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		box-shadow: 0 .03rem .09rem rgba(0, 0, 0, .06)
	}

	._ranking-list-top-box_orrvr_25 ._top_orrvr_36 {
		display: flex;
		align-items: center;
		height: .48rem
	}

	._ranking-list-top-box_orrvr_25 p+p {
		margin-top: .12rem
	}

	._ranking-list-top-box_orrvr_25 ._detail_orrvr_44 {
		margin-left: .1rem;
		color: var(--skin__primary);
		font-size: .22rem;
		cursor: pointer
	}

	._ranking-list-top-box_orrvr_25 ._ranking-last_orrvr_50 {
		margin-left: .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-top-box_orrvr_25 ._ranking-last_orrvr_50 .ranking-icon {
		width: .5rem;
		min-height: .3rem
	}

	._ranking-list-top-box_orrvr_25 ._ranking-award_orrvr_58 {
		margin-left: .1rem;
		color: var(--theme-text-color)
	}

	._ranking-list-top-box_orrvr_25 ._yellow_orrvr_62 {
		color: var(--skin__accent_3)
	}

	._ranking-list-top-box_orrvr_25 ._ranking-list-top-left_orrvr_65 p {
		display: flex;
		align-items: center
	}

	._detailModal_orrvr_70 .ui-dialog__header {
		font-size: .3rem;
		height: .74rem;
		color: var(--theme-text-color)
	}

	._detailModal_orrvr_70 .ui-dialog__content {
		padding: 0 .2rem .2rem
	}

	._announcement_wo97m_17 {
		height: 5rem
	}

	._announcement_wo97m_17 .loading {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._announcement_wo97m_17 .record-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-radius: .1rem;
		padding: .2rem;
		margin-right: .2rem
	}

	._announcement_wo97m_17 .record-item:nth-child(odd) {
		background-color: var(--skin__bg_1)
	}

	._announcement_wo97m_17 .record-item:nth-child(2n) {
		background-color: var(--theme-main-bg-color)
	}

	._announcement_wo97m_17 .record-item .record-info {
		display: flex;
		align-items: center;
		color: var(--theme-text-color);
		font-size: .2rem;
		text-align: left
	}

	._announcement_wo97m_17 .record-item .record-info img {
		width: .44rem;
		height: .44rem;
		margin-right: .2rem
	}

	._announcement_wo97m_17 .record-item .record-info .record-desc {
		display: flex;
		align-items: center;
		margin-right: .1rem
	}

	._announcement_wo97m_17 .record-item .record-info .record-desc .time {
		width: 1.6rem
	}

	._announcement_wo97m_17 .record-item .amount {
		font-size: .22rem;
		color: var(--skin__accent_3)
	}

	._bet-detail-content_74syr_17 .item {
		margin: 0 .3rem .1rem 0;
		text-align: left
	}

	._bet-detail-content_74syr_17 .item label,
	._bet-detail-content_74syr_17 .item span {
		font-size: .22rem;
		line-height: .28rem;
		color: var(--theme-text-color)
	}

	._bet-detail-content_74syr_17 .item .value {
		margin-left: .1rem;
		color: var(--theme-text-color);
		font-weight: 700
	}

	._detail-list_1qqdz_17 {
		border-radius: .1rem
	}

	._detail-list_1qqdz_17 .list-item {
		display: flex
	}

	._detail-list_1qqdz_17 .list-item>div {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._detail-list_1qqdz_17 .list-item>div:first-child,
	._detail-list_1qqdz_17 .list-item>div:last-child {
		flex: none;
		width: 30%
	}

	._detail-list_1qqdz_17 .head {
		height: .8rem;
		background-color: var(--skin__bg_1);
		color: var(--theme-text-color);
		font-size: .24rem;
		border-radius: .1rem;
		border: var(--lobby__px) solid var(--theme-color-line);
		margin-right: .3rem
	}

	._detail-list_1qqdz_17 .body {
		height: .7rem;
		font-size: .2rem;
		color: var(--theme-text-color);
		border-radius: .1rem;
		margin-right: .3rem
	}

	._detail-list_1qqdz_17 .body div {
		line-height: .24rem
	}

	._detail-list_1qqdz_17 .body:nth-child(2n) {
		background-color: var(--skin__bg_1)
	}

	._detail-list_1qqdz_17 .body:nth-child(odd) {
		background-color: var(--theme-main-bg-color)
	}

	._detail-list_1qqdz_17 .body .reward-time {
		display: inline-block;
		width: 1.2rem;
		white-space: pre-wrap;
		line-height: .24rem
	}

	._detail-list_1qqdz_17 .body .lucky-text {
		color: var(--skin__accent_3)
	}

	._detail-list_1qqdz_17 .list-main {
		max-height: 3.5rem
	}

	._bet-detail-content_1qqdz_71 {
		margin-top: .3rem
	}

	._bet-detail-content_1qqdz_71 .item {
		margin: 0 .3rem .1rem 0;
		text-align: left
	}

	._bet-detail-content_1qqdz_71 .item label,
	._bet-detail-content_1qqdz_71 .item span {
		font-size: .2rem;
		line-height: .28rem;
		color: var(--theme-text-color)
	}

	._bet-detail-content_1qqdz_71 .item .value {
		margin-left: .1rem;
		color: var(--theme-text-color);
		font-weight: 700
	}

	._base-info-wrap_wkq00_17 {
		border-bottom: var(--lobby__px) solid var(--theme-color-line)
	}

	._base-info-wrap_wkq00_17 .bet-tips {
		margin-bottom: .2rem;
		font-size: .22rem;
		color: var(--theme-text-color)
	}

	._base-info-wrap_wkq00_17 .bet-tips>span:nth-child(1) {
		margin: 0 .05rem;
		color: var(--theme-text-color)
	}

	._base-info-wrap_wkq00_17 .bet-tips>span:nth-child(2) {
		margin: 0 .05rem;
		color: var(--skin__accent_3)
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: .2rem;
		color: var(--theme-text-color);
		font-size: .24rem
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .info .label {
		margin-right: .1rem
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .info .value {
		color: var(--skin__accent_3)
	}

	._base-info-wrap_wkq00_17 ._base-info_wkq00_17 .btn {
		padding: .2rem 0;
		color: var(--skin__primary);
		font-size: .24rem;
		line-height: 1;
		cursor: pointer
	}

	html[data-gap-supported="0"] ._base-info-wrap_wkq00_17 ._base-info_wkq00_17>*+* {
		margin-left: .2rem
	}

	._bet-detail_wkq00_59 {
		width: 6.9rem
	}

	._bet-detail_wkq00_59 .ui-dialog__main {
		padding: .2rem 0 .3rem .3rem;
		min-height: max-content
	}

	._bet-detail_wkq00_59 .ui-dialog__main .ui-dialog__header {
		padding: 0;
		color: var(--theme-text-color)
	}

	._bet-detail_wkq00_59 .ui-dialog__main .ui-dialog__content {
		margin-top: .3rem;
		padding: 0
	}

	._my-record_fupzb_17 {
		height: 5rem
	}

	._my-record_fupzb_17 .loading {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._my-record_fupzb_17 .ui-empty {
		height: 100%
	}

	._my-record_fupzb_17 .record-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-radius: .1rem;
		padding: .2rem
	}

	._my-record_fupzb_17 .record-item:nth-child(odd) {
		background-color: var(--skin__bg_1)
	}

	._my-record_fupzb_17 .record-item:nth-child(2n) {
		background-color: var(--theme-main-bg-color)
	}

	._my-record_fupzb_17 .record-item .record-info {
		display: flex;
		align-items: center;
		color: var(--theme-text-color);
		font-size: .2rem;
		text-align: left
	}

	._my-record_fupzb_17 .record-item .record-info img {
		width: .44rem;
		height: .44rem;
		margin-right: .2rem
	}

	._my-record_fupzb_17 .record-item .record-info .record-desc {
		display: flex;
		align-items: center;
		margin-right: .1rem
	}

	._my-record_fupzb_17 .record-item .record-info .record-desc .time {
		width: 1.6rem
	}

	._my-record_fupzb_17 .record-item .amount {
		font-size: .22rem;
		color: var(--skin__accent_3)
	}

	._task_163pu_17 ._loading_163pu_17 {
		height: 5rem;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._task_163pu_17 ._task-desc_163pu_24 {
		color: var(--theme-text-color)
	}

	._task_163pu_17 ._lucky-integral_163pu_27 {
		color: var(--skin__accent_3)
	}

	._task_163pu_17 .task-list {
		padding-right: .2rem
	}

	._task_163pu_17 .task-list .ui-table__thead {
		background-color: var(--skin__bg_1)
	}

	._task_163pu_17 .task-list .ui-table__cell {
		min-height: .7rem;
		border-radius: .1rem
	}

	._task_163pu_17 .task-list .ui-table__cell:nth-child(2n) {
		background-color: var(--skin__bg_1)
	}

	._task_163pu_17 .task-list .ui-table__cell:nth-child(odd) {
		background-color: var(--theme-main-bg-color)
	}

	._turntable_1i0ek_17 {
		position: relative;
		width: 5rem;
		margin: .2rem auto
	}

	._turntable_1i0ek_17 .wheel {
		width: 100%;
		height: 5rem;
		background-size: 100% 100%;
		transition: transform 5s ease-in-out
	}

	._turntable_1i0ek_17 .whell-btn {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 1.683rem;
		width: 1.65rem;
		height: 1.825rem;
		margin: auto;
		background-position: 0 0;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center
	}

	._turntable_1i0ek_17 .whell-btn .draw {
		position: relative;
		width: 1.5rem;
		color: var(--theme-jackpot-num-bg-color-1);
		line-height: 1.2;
		text-align: center;
		font-size: .28rem;
		transform: translateY(.07rem)
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(hi) {
		margin-top: .12rem;
		font-size: .28rem
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(it) {
		margin-top: .08rem
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(it) p {
		transform: scale(.85)
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(ja) {
		margin-top: 0
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(tr) span {
		-webkit-box-orient: inherit;
		word-break: keep-all
	}

	._turntable_1i0ek_17 .whell-btn .draw:lang(ru)>span>span {
		display: block !important;
		transform: scale(.8)
	}

	._turntable_1i0ek_17 .wheel-pointer {
		position: absolute;
		top: -.05rem;
		left: 1.6rem;
		margin: auto;
		width: 1.758rem;
		height: 3.208rem;
		background-position: 0 0;
		background-size: 100% 100%
	}

	._turntable_1i0ek_17 .wheel-pointer>img {
		position: relative;
		left: .06rem;
		width: 1.667rem;
		height: 3.208rem;
	}

	._turntable_1i0ek_17._turntable-style8_1i0ek_89 ._whell-item_1i0ek_89,
	._turntable_1i0ek_17._turntable-style10_1i0ek_89 ._whell-item_1i0ek_89 {
		width: 1.1rem
	}

	._turntable_1i0ek_17._turntable-style12_1i0ek_92 ._whell-item_1i0ek_89 {
		width: .9rem
	}

	._whell-item_1i0ek_89 {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 10;
		width: 1.24rem;
		margin: auto;
		height: 4.458rem;
		color: var(--theme-jackpot-num-bg-color-1);
		font-size: .22rem;
		text-align: center
	}

	._whell-item_1i0ek_89 ._center_1i0ek_110 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: .56rem
	}

	._whell-item_1i0ek_89 p {
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		font-size: .22rem;
		line-height: .24rem;
		word-break: break-all
	}

	._whell-item_1i0ek_89 img {
		width: .665rem;
		height: .665rem
	}

	._winning_1i0ek_133 {
		animation: _winning_1i0ek_133 .2s 5 linear
	}

	@keyframes _winning_1i0ek_133 {
		0% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}

	._turntable-tabs_1yc53_62 {
		display: flex;
		justify-content: center
	}

	._turntable-tabs_1yc53_62>div {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 2.1rem;
		height: .81rem;
		text-align: center;
		border: thin solid var(--theme-color-line);
		border-radius: .1rem
	}

	._turntable-tabs_1yc53_62>div:lang(hi) {
		box-shadow: 0 .05rem .18rem rgba(174, 184, 199, .2)
	}

	._turntable-tabs_1yc53_62>div:not(:nth-child(1)) {
		margin-left: .18rem
	}

	._turntable-tabs_1yc53_62>div p {
		width: 100%;
		color: var(--theme-text-color);
		font-size: .3rem;
		line-height: 1.2
	}

	._turntable-tabs_1yc53_62>div p:not(:lang(zh)):not(:lang(zh_hk)) {
		font-size: .22rem
	}

	._turntable-tabs_1yc53_62>div span {
		color: var(--theme-text-color);
		font-size: .24rem
	}

	._turntable-tabs_1yc53_62>div span:not(:lang(zh)):not(:lang(zh_hk)) {
		font-size: .18rem
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99 {
		border: none
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99 p,
	._turntable-tabs_1yc53_62>div._active_1yc53_99 span {
		color: var(--theme-jackpot-num-bg-color-1)
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99._silver_1yc53_106 {
		background-color: var(--theme-event-luck-wheel-silver)
	}

	._turntable-tabs_1yc53_62>div._active_1yc53_99._gold_1yc53_109 {
		background-color: var(--theme-event-luck-wheel-gold);
	}
	._turntable-tabs_1yc53_62>div._active_1yc53_99._diamond_1yc53_112 {
		background-color: var(--theme-event-luck-wheel-diamond)
	}
</style>
<style scoped>
	.R57xbU1vEwuho81iaSVT-conter{
		font-size: .2rem;
	}
	.R57xbU1vEwuho81iaSVT-conter .ant-col {
		-ms-flex-align: center;
		align-items: center;
		color: var(--theme-text-color-darken);
		display: -ms-flexbox;
		display: flex;
	}
	
	.R57xbU1vEwuho81iaSVT-conter .van-row {
		justify-content: center;
		display: flex;
		align-items: center;
	}
	
	.R57xbU1vEwuho81iaSVT-conter .van-col {
		margin-bottom: .2rem;
	}
	
	.R57xbU1vEwuho81iaSVT-conter .van-col label {
		color: var(--theme-text-color-lighten);
		margin-right: .1rem;
	}
	
	.R57xbU1vEwuho81iaSVT-conter .currencyAmount {
		color: var(--theme-text-color-darken);
	}
	.R57xbU1vEwuho81iaSVT-conter .yellow{
		color: var(--theme-secondary-color-finance);
	}
	.R57xbU1vEwuho81iaSVT-conter .red{
		color: var(--theme-secondary-color-error);
	}
	.footerOCmens{
		    border-radius: .1rem;
		    border: 0.01rem solid var(--theme-color-line);
		    background-color: var(--theme-main-bg-color);
		    color: var(--theme-text-color-darken);
	}
	.conterms{
		display: flex;
		align-items: center;
		justify-content: center;
		height: .8rem;
		font-size: .24rem;
	}
	.conterms:nth-child(2n){
		background-color: var(--theme-main-bg-color);
	}
	.conterms div{
		width: 50%;
		box-sizing: border-box;
		text-align: center;
	}
	.orkXHvtNM5R_5twq6l5I {
	    background-color: var(--theme-main-bg-color);
	    bottom: 0;
	    -webkit-box-shadow: 0 -.03rem .1rem 0 rgba(0,0,0,.1);
	    box-shadow: 0 -.03rem .1rem 0 rgba(0,0,0,.1);
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex: none;
	    flex: none;
	    height: 1.3rem;
	    position: fixed;
	    z-index: 2
	}
	.orkXHvtNM5R_5twq6l5I>button {
	    margin: .2rem auto auto;
		border-radius: .1rem;
	}
	 .orkXHvtNM5R_5twq6l5I>button:first-child {
	    margin-left: .2rem;
	    margin-right: .1rem
	}
	.orkXHvtNM5R_5twq6l5I>button:last-child {
	    margin-left: .1rem;
	    margin-right: .2rem
	}
	.orkXHvtNM5R_5twq6l5I .RRWQlUJLCPB59ggBUdFl {
	    background-color: var(--theme-main-bg-color);
	    border: thin solid var(--theme-primary-color);
	    color: var(--theme-primary-color)!important;
	    color: var(--theme-primary-font-color);
	    font-size: .24rem;
	    height: .7rem;
	    line-height: .55rem;
	    margin-right: 0;
	    text-align: center;
	    width: 3.45rem
	}
	 .orkXHvtNM5R_5twq6l5I .yJrr5gS3ZL4NGzZkaPXH {
	    color: var(--theme-primary-font-color);
	    font-size: .24rem;
	    height: .7rem;
	    line-height: .55rem;
	    text-align: center;
	    width: 3.45rem
	}
	.ant-btn.ant-btn-primary1{
		background-color: var(--theme-disabled-bg-color);
		border-color: var(--theme-disabled-bg-color);
		color: var(--theme-disabled-font-color);
	}
	.ant-btn.ant-btn-primary{
		background-color: var(--theme-primary-color);
		border-color: var(--theme-primary-color)
	}
</style>